(function () {
  'use strict';

  // Removes orphaned Personalisation charge lines that were added alongside a
  // bundle line item (they share a hidden _bundle_group property). When the
  // parent bundle line is removed from the cart, its monogram charges go too.
  //
  // Legacy monogram lines added from the standard PDP have no _bundle_group
  // property and are never touched by this script.

  var busy = false;
  var timer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function isPersonalisationLine(item) {
    var type = (item.product_type || '').toLowerCase();
    return type === 'personalisation';
  }

  function groupOf(item) {
    return (item.properties && item.properties._bundle_group) || null;
  }

  function refreshCartUi() {
    try {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart(false);
        return;
      }
    } catch (e) { /* fall through */ }
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
    }
  }

  function cleanup() {
    if (busy) return;
    busy = true;

    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var aliveGroups = {};
        var orphanKeys = [];

        items.forEach(function (item) {
          var g = groupOf(item);
          if (g && !isPersonalisationLine(item)) aliveGroups[g] = true;
        });

        items.forEach(function (item) {
          var g = groupOf(item);
          if (g && isPersonalisationLine(item) && !aliveGroups[g]) {
            orphanKeys.push(item.key);
          }
        });

        if (!orphanKeys.length) {
          busy = false;
          return;
        }

        var updates = {};
        orphanKeys.forEach(function (key) { updates[key] = 0; });

        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            busy = false;
            refreshCartUi();
          });
      })
      .catch(function () { busy = false; });
  }

  function scheduleCleanup(delay) {
    clearTimeout(timer);
    timer = setTimeout(cleanup, delay || 400);
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = (typeof input === 'string' ? input : (input && input.url)) || '';
      } catch (e) { url = ''; }

      var result = nativeFetch.apply(this, arguments);
      if (/\/cart\/(change|update|clear)/.test(url)) {
        result.then(function () { scheduleCleanup(300); }).catch(function () {});
      }
      return result;
    };
  }

  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && /\/cart\/(change|update|clear)/.test(url)) {
          this.addEventListener('load', function () { scheduleCleanup(300); });
        }
      } catch (e) { /* ignore */ }
      return open.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-item-remove], [data-quantity-button], .cart__item__remove')) {
      scheduleCleanup(900);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleCleanup(600); });
  } else {
    scheduleCleanup(600);
  }
})();
